<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;Patient Search</h2>
    </div>
</div>
<div class="card col-12 pt-2 pb-2">
    <div class="formgroup-inline col-12">
        <div class="field col-3 md:col-2 p-1 mb-0">
            <label for="lastName">Last Name:&nbsp;&nbsp;</label>
            <div class="p-0">
                <input id="lastName"
                       [(ngModel)]="lastName"
                       type="text"
                       class="text-base text-color p-2 col-12"
                       autocomplete="off"
                       (ngModelChange)="checkSearchButtonState()"
                       (keydown.enter)="checkSearchButtonState()" />
            </div>

          
            <!--<input id="lastName" [(ngModel)]="lastName" type="text" class="form-control" autocomplete="off">-->
        </div>
        <div class="field col-3 md:col-2 p-1 mb-0">
            <label for="firstName">First Name:&nbsp;&nbsp;</label>
            <div class="p-0">
                <input id="firstName"
                       [(ngModel)]="firstName"
                       type="text"
                       class="text-base text-color p-2 col-12"
                       autocomplete="off"
                       (ngModelChange)="checkSearchButtonState()"
                       (keydown.enter)="checkSearchButtonState()" />
                <!--<input id="firstName" [(ngModel)]="firstName" type="text" class="form-control" autocomplete="off">-->
            </div>
        </div>
        <div class="field col-2 md:col-2 p-1 mb-0">
            <label for="year">DOB:&nbsp;&nbsp;</label>
            <div class="p-0">
                <p-calendar id="year"
                            [(ngModel)]="dOB"
                            [yearNavigator]="true"
                            yearRange="{{ yearRangeForDatePicker }}"
                            class="text-color col-12"
                            placeholder="mm/dd/yyyy"
                            showButtonBar="true"
                            (ngModelChange)="checkSearchButtonState()"></p-calendar>
                <!--<input id="year" [(ngModel)]="dOB" class="text-base text-color surface-overlay p-2 surface-border border-round appearance-none outline-none focus:border-primary" />-->
                <!--<input id="year" [(ngModel)]="dOB" type="date" class="form-control" autocomplete="off">-->
            </div>
        </div>
        <div class="field col-2 md:col-2 p-1 mb-0">
            <label for="mrn">MRN:&nbsp;&nbsp;</label>
            <div class="p-0">
                <input id="mrn"
                       [(ngModel)]="mRN"
                       type="text"
                       class="text-base text-color p-2 col-12"
                       autocomplete="off"
                       (ngModelChange)="checkSearchButtonState()"
                       (keydown.enter)="checkSearchButtonState()" />
            </div>
        </div>
        <span class="pt-3">
            &nbsp;
            <button pButton
                    type="button"
                    icon="pi pi-search"
                    label="Search"
                    (click)="getpatientList(1, 'fullname', 'Asc')"
                    class="ui-button-plain buttonWidth-8 ml-3"
                    [disabled]="searchButtonDisabled"></button>
            &nbsp;<p-button label="Clear"
                            severity="secondary"
                            icon="pi pi-refresh"
                            class="buttonWidth-8 fl ml-1"
                            (click)="clearFilter()"></p-button>
        </span>
    </div>
</div>



<!--<div #tableWrapper tabindex="0" (keydown.enter)="onEnterKey()">-->
    <p-table #table
             *ngIf="patients"
             [resetPageOnSort]="false"
             lazy="true"
             [lazyLoadOnInit]="false"
             (onLazyLoad)="nextPage($event)"
             [totalRecords]="patients.totalRecords"
             [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
             [columns]="cols"
             [alwaysShowPaginator]="false"
             [rows]="rows"
             [paginator]="showRecords"
             [value]="patients.data"
             selectionMode="single"
             [sortOrder]="1"
             sortField="fullName"
             [(selection)]="selectedPatient"
             [responsive]="true">
        <!--<ng-template pTemplate="caption">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div> Patient List</div>


              </div>
          </ng-template>-->

        <ng-template pTemplate="header" let-columns>
            <tr *ngIf="showRecords == true">
                <th></th>
                <th *ngFor="let col of columns"
                    [hidden]="col.hidden"
                    [pSortableColumn]="col.field">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
            </tr>
        </ng-template>


        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData" (click)="getPatientDetails(rowData)">
                <td>
                    <!--<button pButton type="button" icon="pi pi-user" class="ui-button-info" [ngStyle]="{'background-color': '#142066','color':'white'}" style="font-size: 0.7em;" (click)="getPatientDetails(rowData['patientId'],rowData['fullName'])"></button>-->
                    <p-button icon="pi pi-user"
                              [rounded]="true"
                              severity="info"
                              (click)="getPatientDetails(rowData)" />
                </td>
                <td *ngFor="let col of columns" [hidden]="col.hidden">



                <!--<span class="column-title">{{col.header}}</span>-->
                {{ rowData[col.field] }}
                </td>
            </tr>
        </ng-template>


        <ng-template pTemplate="emptymessage">
            <div class="w-12 bg-white">
                <div class="" style="text-align: center">
                    <img _ngcontent-ng-c683320295=""
                         class="profile-image"
                         style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                         src="assets/imagesNew/table_error.png" />
                </div>
                <hr style="margin-bottom: 0.5rem" />
                <div class=""
                     style="text-align: center; font-size: larger; color: #1d428f">
                    <i>No records found</i>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div style="border-radius: 10px" *ngIf="state.totalRecords > pageSize">
                Showing {{ state.page * state.rows + 1 }} to
                {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }}
                records.
            </div>
        </ng-template>
    </p-table>


    <!--</div>-->


    <!-- Password Expire Popup message-->

    <p-dialog [(visible)]="isViewedMessage" [draggable]="false" [modal]="true"
              [style]="{ width: '90%', maxWidth: '400px' }" (onHide)="onDialogClose()">
        <p-header>
            Password Expire
        </p-header>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <span class="d-flex justify-content-center align-items-center">
                        <img src="/../../../assets/imagesNew/password_warning.png"
                             alt="Warning Icon"
                             class="img-fluid"
                             style="max-width: 200px; height: auto;" />
                    </span>
                </div>
                <h5 class="col-12 text-center mt-3 mb-0">
                    {{pNearExpirMessage}}
                </h5>
            </div>

            <!-- Buttons Section with Spacing -->
            <div class="row justify-content-center mt-3">
                <div class="col-12 d-flex justify-content-between gap-4">
                    <button pButton type="submit" label="Change Password" icon="pi pi-save" (click)="goToChangePassword()"
                            class="p-button-plain flex-grow-1 px-4"></button> &nbsp;
                    <button pButton type="button" icon="pi pi-times-circle" label="Continue"
                            class="ui-button-secondary flex-grow-1 px-4" (click)="ackOK()"></button>
                </div>
            </div>
        </div>
    </p-dialog>
